import api from '../config/axiosConfig';


const searchService = {
    /**
     * Recherche globale dans plusieurs modules
     * @param {string} query Terme de recherche
     * @param {string} module Filtre par module (tous, clients, circuits, factures)
     * @param {object} filters Filtres additionnels (date, statut)
     */
    async globalSearch(query, module = 'tous', filters = {}) {
        try {
            if (!query || query.trim() === '') {
                return [];
            }

            const response = await api.get('/search_test.php', {
                params: {
                    q: query.trim(),
                    module,
                    ...filters,
                    _limit: 10
                },
                // Accepter les réponses 404 comme des réponses valides
                validateStatus: (status) => status < 500
            });

            // Si la réponse est vide ou invalide
            if (!response.data) {
                console.warn('Réponse vide du serveur');
                return [];
            }

            // Si la réponse est un tableau, le retourner directement
            if (Array.isArray(response.data)) {
                return response.data;
            }

            // Si la réponse contient une propriété 'data' qui est un tableau
            if (response.data.data && Array.isArray(response.data.data)) {
                return response.data.data;
            }

            // Si la réponse contient une erreur
            if (response.data.error) {
                console.error('Erreur du serveur:', response.data.message || response.data.error);
                return [];
            }

            // Si la réponse a un format inattendu
            console.warn('Format de réponse inattendu:', response.data);
            return [];

        } catch (error) {
            console.error('Erreur lors de la recherche globale:', error);
            // Retourner un tableau vide en cas d'erreur pour éviter les plantages
            return [];
        }
    },

    // Normalise les objets disparates en un format unique pour l'affichage
    normalizeResult(item, type) {
        switch (type) {
            case 'client':
                return {
                    id: item.id,
                    type: 'client',
                    title: item.libelle || `${item.nom} ${item.prenom}`,
                    description: `Client - Email: ${item.email || 'N/A'}`,
                    module: 'Clients',
                    status: 'Actif', // Statut par défaut si non présent
                    date: null
                };
            case 'circuit':
                return {
                    id: item.id,
                    type: 'circuit',
                    title: item.nom,
                    description: `Circuit - ${item.trajet || 'Sans trajet'}`,
                    module: 'Production',
                    status: item.etat || 'En cours',
                    date: item.dateDepart
                };
            case 'facture':
                return {
                    id: item.id,
                    type: 'facture',
                    title: `Facture #${item.id}`,
                    description: `Montant: ${item.montant} FCFA`,
                    module: 'Facturation',
                    status: item.statut || 'En attente',
                    date: item.date
                };
            default:
                return { id: Math.random(), title: 'Inconnu', type: 'unknown' };
        }
    }
};

export default searchService;
